import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditTracking from 'src/components/editor/EditTracking';
import { RootState } from 'src/store';

const ShortAnswerSurveyTracking_0201: FC = () => {
  const dispatch = useDispatch();

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);

  const style = `
    .root_tracking_0201 {
      background: none;

      .center_horizon {
        width: 100%;
      }
      .logo {
        opacity: 0;
      }

      .center_wrapper {
        width: 100%;
      }
      .bottom button {
        background: none;
      }
      
      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view root_view_0201 root_tracking_0201">
        <div className="template">
          <div className="tracking_center center_horizon top_wrapper">
            <EditTracking
              value={tracking?.close_0201?.[currentIndex]}
              type="close_0201"
            />
          </div>
          <div className="center_wrapper">
            <div className="title" />
            <div className="logo">
              <div className="logo_inner">
                <button />
              </div>
            </div>
            <div className="sub_title" />
          </div>
          <div className="center_horizon bottom">
            <button className="tracking_center button">
              <EditTracking
                value={tracking?.button_0201?.[currentIndex]}
                type="button_0201"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShortAnswerSurveyTracking_0201;
